exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-order-performance-container .sweet-modal.is-alert{width:974px}.product-order-performance-container .sweet-modal.is-alert .sweet-content{padding:28px 32px 16px 32px}", ""]);

// exports
